import creatorImage from "@src/presentation/assets/images/sample-drop/creator.jpeg";
import dropImage from "@src/presentation/assets/images/sample-drop/drop.jpeg";
import foreverImage from "@src/presentation/assets/images/sample-drop/forever.jpeg";
import futureImage from "@src/presentation/assets/images/sample-drop/future.jpeg";
import pastImage from "@src/presentation/assets/images/sample-drop/past.jpeg";
import presentImage from "@src/presentation/assets/images/sample-drop/present.jpeg";
import { Creator } from "@src/core/models/creator";
import { Drop } from "@src/core/models/drop";
import { Offer } from "@src/core/models/offer";

export const drop: Drop = {
  createdAt: new Date("2022-03-10T20:00:00"),
  createdBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  creatorId: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  id: "10020ac0-b413-4029-9674-a1c7378f4f82",
  endsAt: new Date("2023-04-10T20:00:00"),
  promotionDescription:
    "This collection muses on the trials and tribulations of forging ahead through the darkness, shaping time and space into beacons of light that clear the fog. It is in these steps forward, while surrendering wholly to the present, that we realize our desires.",
  imageUrl: dropImage,
  promotionHeadline: "Building the Future by 0xF00bAr",
  startsAt: new Date("2021-03-10T20:00:00"),
  updatedAt: new Date("2022-03-10T20:00:00"),
  updatedBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
};

export const past: Offer = {
  assetIds: ["d3f14330-93dc-420e-a156-6a41d6422ae9"],
  createdAt: new Date("2022-03-10T20:00:00"),
  createdBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  description:
    "Endless repeating circles of light shoot backwards towards the source that we came from.",
  dropId: "10020ac0-b413-4029-9674-a1c7378f4f82",
  editionsCount: 1,
  name: "Past",
  id: "d3f14330-93dc-420e-a156-6a41d6422ae9",
  mediaUrl: pastImage,
  previewUrlLarge: pastImage,
  previewUrlSmall: pastImage,
  availableCount: "0",
  updatedAt: new Date("2022-03-10T20:00:00"),
  updatedBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  price: 0.01,
};

export const present: Offer = {
  assetIds: ["d3f14330-93dc-420e-a156-6a41d6422ae9"],
  createdAt: new Date("2022-03-10T20:00:00"),
  createdBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  description:
    "Kinetic energy of the quantum possibilities that exist in the now.",
  dropId: "10020ac0-b413-4029-9674-a1c7378f4f82",
  editionsCount: 1,
  name: "Present",
  id: "9650f31b-4267-440a-a470-e7f71906826e",
  mediaUrl: presentImage,
  previewUrlLarge: presentImage,
  previewUrlSmall: presentImage,
  availableCount: "1",
  updatedAt: new Date("2022-03-10T20:00:00"),
  updatedBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  price: 0.01,
};

export const future: Offer = {
  assetIds: ["d3f14330-93dc-420e-a156-6a41d6422ae9"],
  createdAt: new Date("2022-03-10T20:00:00"),
  createdBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  description:
    "What remains unknown must not be feared. Rather, trust and allow life to unfold the highest possible outcomes for you.",
  dropId: "10020ac0-b413-4029-9674-a1c7378f4f82",
  editionsCount: 1,
  name: "Future",
  id: "2bb34948-911c-4466-90c1-1bbd2fb128fb",
  mediaUrl: futureImage,
  previewUrlLarge: futureImage,
  previewUrlSmall: futureImage,
  availableCount: "1",
  updatedAt: new Date("2022-03-10T20:00:00"),
  updatedBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  price: 0.01,
};

export const forever: Offer = {
  assetIds: ["d3f14330-93dc-420e-a156-6a41d6422ae9"],
  createdAt: new Date("2022-03-10T20:00:00"),
  createdBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  description:
    "What goes around comes around. What goes up must come down. Now and forever. The never-ending circle of life, death and in between. We create to destroy and destroy to create.",
  dropId: "10020ac0-b413-4029-9674-a1c7378f4f82",
  editionsCount: 1,
  name: "Forever",
  id: "10f51b00-6e7e-4b2d-ab08-e4605c9af51b",
  mediaUrl: foreverImage,
  previewUrlLarge: foreverImage,
  previewUrlSmall: foreverImage,
  availableCount: "1",
  updatedAt: new Date("2022-03-10T20:00:00"),
  updatedBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  price: 0.01,
};

export const creator: Creator = {
  bio: "0xF00bAr has been creating magic with light and composition as a digital photographer for brands such as Nike, Gucci, Stussy and more. He also has built up a strong portfolio of personal work that has been exhibited in galleries in NYC, Berlin, and Australia. A lifelong artist and creative storyteller, this drop is a step in his evolution to creating a more immersive world for his biggest collectors and fans. He is based in Brooklyn and travels often.",
  createdAt: new Date("2022-03-10T20:00:00"),
  createdBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  hashId: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  id: "02fbd543-bd42-4330-886a-29a6b34d57d6",
  name: "0xF00bAr",
  profileImageUrl: creatorImage,
  role: "Artist",
  socialMedia: [
    { type: "facebook", url: "https://www.google.com/" },
    { type: "instagram", url: "https://www.google.com/" },
    { type: "pinterest", url: "https://www.google.com/" },
    { type: "twitter", url: "https://www.google.com/" },
    { type: "website", url: "https://www.google.com/" },
  ],
  updatedAt: new Date("2022-03-10T20:00:00"),
  updatedBy: "02fbd543-bd42-4330-886a-29a6b34d57d6",
};

export const offers: Offer[] = [past, present, future, forever];
